// Copyright (c) Move Closer 2022.

import { Authentication, AuthServiceType } from '@movecloser/front-core'
import { Component, Vue } from 'vue-property-decorator'

import { AuthControlServiceType, IAuthControl } from '../../contracts'
import { ILogoutMixin, UserModel } from '../contracts'
import { Inject, logger } from '../../../../support'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Component<LogoutMixin>({
  name: 'LogoutMixin'
})
export class LogoutMixin extends Vue implements ILogoutMixin {
  @Inject(AuthControlServiceType)
  protected readonly authControl!: IAuthControl

  @Inject(AuthServiceType)
  protected readonly authService!: Authentication<UserModel>

  public async logout (): Promise<void> {
    try {
      await this.authControl.logout()
      this.authService.deleteToken()
    } catch (e) {
      logger(e, 'warn')
    }
  }
}
